import {
  ADMIN_AVATAR_FALLBACK_BG,
  ADMIN_AVATAR_FALLBACK_TEXT,
} from '@/config/adminChartTheme';
import React, { useEffect, useState } from 'react';
import ChartCard from '../ChartCard';
import { fetchTopBrandsByGmv } from '../../../services/campaignAnalyticsService';
import millify from 'millify';

interface TopBrand {
  brandId: string;
  brandName: string;
  brandLogo: string;
  brandCategory: string;
  gmv: number;
  cashbackPaid: number;
  roas: number;
  campaignCount: number;
  submissionsCount: number;
}

interface TopBrandsTableProps {
  refreshToken?: number;
}

const TopBrandsTable: React.FC<TopBrandsTableProps> = ({ refreshToken }) => {
  const [data, setData] = useState<TopBrand[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTopBrandsByGmv(5)
      .then((d) => setData(Array.isArray(d) ? d : []))
      .finally(() => setLoading(false));
  }, [refreshToken]);

  return (
    <ChartCard title="Top Brands" subtitle="By GMV generated" loading={loading}>
      {data.length > 0 ? (
        <div className="space-y-3">
          {data.map((b, i) => (
            <div
              key={b.brandId}
              className="flex items-center gap-3 p-3 rounded-2xl hover:bg-[#FAFAFA] transition-colors"
            >
              <span className="text-xs font-bold text-[#9B919D] w-5 shrink-0">
                {i + 1}
              </span>
              <div
                className={`w-9 h-9 rounded-xl overflow-hidden shrink-0 flex items-center justify-center ${ADMIN_AVATAR_FALLBACK_BG}`}
              >
                {b.brandLogo ? (
                  <img
                    src={b.brandLogo}
                    alt={b.brandName}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <span
                    className={`text-xs font-bold ${ADMIN_AVATAR_FALLBACK_TEXT}`}
                  >
                    {b.brandName?.[0]}
                  </span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-[#172B4D] truncate">
                  {b.brandName}
                </p>
                <p className="text-[10px] text-[#9B919D]">
                  {b.brandCategory} · {b.campaignCount} campaigns
                </p>
              </div>
              <div className="text-right shrink-0">
                <p className="text-sm font-bold text-[#172B4D]">
                  €{millify(b.gmv)}
                </p>
                <p className="text-[10px] text-[#9B919D]">{b.roas}x ROAS</p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="h-48 flex items-center justify-center">
          <p className="text-[#9B919D] text-sm">No brand data</p>
        </div>
      )}
    </ChartCard>
  );
};

export default TopBrandsTable;
